import { render } from "./notiFication.vue?vue&type=template&id=02822cdf"
import script from "./notiFication.vue?vue&type=script&lang=js"
export * from "./notiFication.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__